import LoaderComponent from '../common/LoaderComponent';
import React, { PureComponent } from 'react';
import _ from 'lodash';
import moment from 'moment';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import MobileOverlay from '../common/MobileOverlay';
import NumberUtils from '../../utils/NumberUtils';
import SpendingsScreen from './SpendingsScreen';
import BudgetScreen from './BudgetScreen';
import SpendingsHeaderProgressBar from './SpendingsHeaderProgressBar';
import { AccountsModal } from './AccountsModal';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import PropTypes from 'prop-types';

class SpendingsLandingPagesMobile extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    spendingAccountList: PropTypes.array,
    budgetData: PropTypes.array,
    spendListData: PropTypes.array,
    loadSpendingPage: PropTypes.number,
    totalLastMonthValue: PropTypes.array,
    totalCurrentMonthValue: PropTypes.array,
    isNoBudget: PropTypes.bool,
    allBudgetTarget: PropTypes.array,
    lastMonth: PropTypes.string,
    showAccountModal: PropTypes.bool,
    getAllAccountIds: PropTypes.array,
    openFaq: PropTypes.func,
    screenFlagForMobile: PropTypes.number,
    spendingProgressText: PropTypes.object,
  };
  state = {
    headerClass: null,
  };

  getHeaderClass = (e) => {
    this.setState({ headerClass: e });
  };
  budgetCreationScreen = () => {
    SpendingsActionCreator.checkScreenFlag(3);
    if (_.sum(this.props.allBudgetTarget) > 0) {
      this.handleEditBudget();
    } else {
      this.handleCreateBudget();
    }
  };
  budgetDetailedScreen = () => {
    SiteHeaderActionCreator.hideHeaderFlag(true);
    SpendingsActionCreator.checkScreenFlag(1);
  };
  handleCreateBudget = () => {
    this.loadSpendingAction(3);
  };
  handleEditBudget = () => {
    this.loadSpendingAction(4);
  };
  landingScreen = () => {
    SiteHeaderActionCreator.hideHeaderFlag(false);
    SpendingsActionCreator.checkScreenFlag(0);
  };
  loadSpendingAction = (key) => {
    // Get Account List
    if (key === 4) {
      SpendingsActionCreator.getTagListConnection();
      if (!this.props.currentAccFlag) {
        SpendingsActionCreator.handlePotDataSpendings();
      } else {
        //* ** BOW-1192  POT ERROR SERVICE  IS BEEN CALLED FOR ONLY CURRENT ACC FOR EDIT SPENDINGS***
        SpendingsActionCreator.handlePotDataSpendingsError();
      }
    } else if (key === 3) {
      if (!this.props.currentAccFlag) {
        SpendingsActionCreator.handlePotDataSpendings();
      } else {
        //* ** BOW-1304  POT ERROR SERVICE  IS BEEN CALLED FOR ONLY CURRENT ACC FOR CREATE SPENDINGS***
        SpendingsActionCreator.handlePotDataSpendingsError();
      }
      SpendingsActionCreator.getSpendingPageWithKey(key);
    } /* else {
				SpendingsActionCreator.getTagListConnection();
				SpendingsActionCreator.getBudgetPreferencesConnection();
				SpendingsActionCreator.getAccountsList();
				SpendingsActionCreator.getSpendingPageWithKey(key);
			}*/
  };
  monthDetailedScreen = () => {
    SiteHeaderActionCreator.hideHeaderFlag(true);
    SpendingsActionCreator.checkScreenFlag(2);
  };
  smClose = () => {
    SpendingsActionCreator.closeAccountModal();
  };
  totalDaysLeft = () => {
    const currentDate = moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY');
    const lastDateOfTheMonth = moment(
      moment().endOf('month').format('DD/MM/YYYY'),
      'DD/MM/YYYY'
    );
    return lastDateOfTheMonth.diff(currentDate, 'days');
  };
  render() {
    const content = this.props.content;
    const budgetData = this.props.budgetData;
    const isNoBudget = this.props.isNoBudget;
    const spendListData = this.props.spendListData;
    const allBudgetTarget = this.props.allBudgetTarget;
    const showAccountModal = this.props.showAccountModal;
    const totalBudgetData = _.sum(allBudgetTarget);
    const totalLastMonthValue = _.sum(this.props.totalLastMonthValue).toFixed(
      2
    );
    const totalCurrentMonthValue = _.sum(
      this.props.totalCurrentMonthValue
    ).toFixed(2);
    const labelThisMonth = content.spendingHeaderThisMonthText;
    const monthNameCalculation = Number(moment().format('MM') - 2);
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let pageData;
    let budgetDataBox;
    let monthDataBox;
    let accountModal;
    let noBudgetMessage;
    let displayPageHeaderFlag;
    let selectedTabOption = 'spendings';
    let daysleftdisplay = 0;
    if (Number(totalBudgetData) !== 0) {
      budgetDataBox = (
        <section>
          <h5 className="text-center">
            {labelThisMonth} {content.spendingHeaderTitle1}{' '}
          </h5>
          <div className="spendings-progress">
            <SpendingsHeaderProgressBar
              spendingProgressText={this.props.spendingProgressText}
              content={content}
              leftValue={Number(totalCurrentMonthValue)}
              rightValue={Number(totalBudgetData)}
            />
          </div>
          <section className="text-center ">
            <h6>{labelThisMonth}</h6>
            <h4>
              {NumberUtils.appendCurrency('{}', Number(totalCurrentMonthValue))}
            </h4>
          </section>
          <section
            className="text-center budget"
            onClick={this.budgetCreationScreen}
          >
            <h6>
              {content.spendingProgressText1}
              <span className="icon icon-edit" />
            </h6>
            <h4>{NumberUtils.appendCurrency('{}', Number(totalBudgetData))}</h4>
          </section>
          <button
            id="1"
            type="button"
            className="btn btn-link text-center"
            onClick={this.budgetDetailedScreen}
          >
            {content.spendingCloserLook}
          </button>
        </section>
      );
    } else {
      selectedTabOption = 'spendings1';
      budgetDataBox = (
        <section className="no-budget text-center">
          <button
            type="button"
            className="btn btn-link text-center"
            onClick={this.budgetCreationScreen}
          >
            {content.spendingHeaderButtonLabel2}
          </button>
        </section>
      );
      noBudgetMessage = (
        <h5 className="text-center">
          {content.spendingHeaderNoBudgetWatning1}
        </h5>
      );
    }
    monthDataBox = (
      <section>
        <h5 className="text-center">
          {content.spendingHeaderTitle2}{' '}
          {_.nth(monthNames, monthNameCalculation)}
        </h5>
        <div className="spendings-progress">
          <SpendingsHeaderProgressBar
            content={content}
            leftValue={Number(totalCurrentMonthValue)}
            rightValue={Number(totalLastMonthValue)}
            spendingProgressText={moment().subtract(1, 'months').format('MMMM')}
          />
        </div>

        <section className="text-center">
          <h6>{labelThisMonth}</h6>
          <h4>
            {NumberUtils.appendCurrency('{}', Number(totalCurrentMonthValue))}
          </h4>
        </section>
        <section className="text-center">
          <h6>{_.nth(monthNames, monthNameCalculation)}</h6>
          <h4>
            {NumberUtils.appendCurrency('{}', Number(totalLastMonthValue))}
          </h4>
        </section>

        <button
          id="2"
          type="button"
          className="btn btn-link text-center"
          onClick={this.monthDetailedScreen}
        >
          {content.spendingCloserLook}
        </button>
      </section>
    );
    if (Number(this.props.screenFlagForMobile) === 0) {
      if (this.totalDaysLeft() !== 1) {
        daysleftdisplay = (
          <section className="text-center">
            <h5>
              <span className="icon icon-calendar" />
              {this.totalDaysLeft()} {content.spendingDaysLeftText}
            </h5>
          </section>
        );
      } else {
        daysleftdisplay = (
          <section className="text-center">
            <h5>
              <span className="icon icon-calendar" />
              {this.totalDaysLeft()} day left in this month
            </h5>
          </section>
        );
      }
      pageData = (
        <div className="full-height">
          <div className="calendar-row">
            {daysleftdisplay}
            <section className="text-left">
              <MobileOverlay
                getHeaderClass={this.getHeaderClass}
                selectedTab={selectedTabOption}
                content={this.props.content}
                openFaq={this.props.openFaq}
                handleEditBudget={this.handleEditBudget}
                handleCreateBudget={this.handleCreateBudget}
              />
            </section>
          </div>
          <div className="scroll-wrapper mobile-landing">
            <div className="spendings-boxes">
              {noBudgetMessage}
              <div className="budget-box">{budgetDataBox}</div>
              <div className="month-box">{monthDataBox}</div>
            </div>
          </div>
        </div>
      );
    } else {
      displayPageHeaderFlag = 'noheader';
      if (Number(this.props.screenFlagForMobile) === 1) {
        pageData = (
          <BudgetScreen
            content={content}
            budgetData={budgetData}
            totalCurrentMonthValue={totalCurrentMonthValue}
            allBudgetTarget={allBudgetTarget}
            isNoBudget={isNoBudget}
            _detailedScreen={this.landingScreen}
          />
        );
      } else if (Number(this.props.screenFlagForMobile) === 2) {
        pageData = (
          <SpendingsScreen
            content={content}
            spendListData={spendListData}
            totalLastMonthValue={totalLastMonthValue}
            totalCurrentMonthValue={totalCurrentMonthValue}
            isNoBudget={isNoBudget}
            _detailedScreen={this.landingScreen}
          />
        );
      } else {
        pageData = (
          <div>
            <div className="main-container">
              <LoaderComponent type="large" />
            </div>
          </div>
        );
      }
    }
    if (showAccountModal) {
      accountModal = (
        <AccountsModal
          getAllAccountIds={this.props.getAllAccountIds}
          content={content}
          onHide={this.smClose}
          spendingAccountList={this.props.spendingAccountList}
        />
      );
    }
    return (
      <div className="full-height">
        <div className={`spending main-container ${displayPageHeaderFlag}`}>
          <div className="content-wrapper spendings-landings">
            <div className="full-height">{pageData}</div>
          </div>
          {accountModal}
        </div>
      </div>
    );
  }
}
export default SpendingsLandingPagesMobile;
